// import uirouter from 'angular-ui-router';
import routing from './workPlanParametrization.route'
// import datelocale from './workPlanParametrization.datelocale'
import run from './workPlanParametrization.run'
import workPlanParametrizationListCtrl from './list/workPlanParametrizationListCtrl'
import workPlanCreateCtrl from './create/workPlanCreateCtrl'
import workPlanViewCtrl from './view/workPlanViewCtrl'
import WorkPlanParametrizationSrv from './workPlanParametrizationSrv'
import workPlanHoursOfDedicatedViewCtrl from './create/workPlanHoursOfDedicatedViewCtrl'
import workPlanAssignmentOfEvaluatorsCtrl from './reviewers/workPlanAssignmentOfEvaluatorsCtrl'
import workPlanCreateModalCtrl from './create/workPlanCreateModalCtrl'
import setupTeacherActivitiesCtrl from './activities/setupTeacherActivitiesCtrl'
import criteriaListViewCtrl from './criteria/criteriaListViewCtrl'
import specialSituationsCtrl from './special/specialSituationsCtrl'
import activateWorkPlanCtrl from './activateWorkPlan/activateWorkPlanCtrl'
import setupTeacherTypeModulesCtrl from './modules/setupTeacherTypeModulesCtrl'
import GlobalConfig from '../../../globals/globalConfig.json'

export default angular.module('workPlanParametrization.workPlanParametrization', [WorkPlanParametrizationSrv])
  .config(routing)
  // .config(datelocale)
  .controller('WorkPlanParametrizationListCtrl', workPlanParametrizationListCtrl)
  .controller('WorkPlanCreateCtrl', workPlanCreateCtrl)
  .controller('WorkPlanViewCtrl', workPlanViewCtrl)
  .controller('WorkPlanHoursOfDedicatedViewCtrl', workPlanHoursOfDedicatedViewCtrl)
  .controller('WorkPlanAssignmentOfEvaluatorsCtrl', workPlanAssignmentOfEvaluatorsCtrl)
  .controller('workPlanCreateModalCtrl', workPlanCreateModalCtrl)
  .controller('SetupTeacherActivitiesCtrl', setupTeacherActivitiesCtrl)
  .controller('CriteriaListViewCtrl', criteriaListViewCtrl)
  .controller('SpecialSituationsCtrl', specialSituationsCtrl)
  .controller('SetupTeacherTypeModulesCtrl', setupTeacherTypeModulesCtrl)
  .controller('ActivateWorkPlanCtrl', activateWorkPlanCtrl)
  .run(run)
  .constant('workPlanParametrization', [{
    'title': 'Parametrización',
    'icon': 'mdi-image-tune',
    'rolesAllowed': [GlobalConfig.userRolesIds.workPlanAdmin,GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.support,GlobalConfig.userRolesIds.profileAdmin,GlobalConfig.userRolesIds.adminPortfolio],
    'subMenu': [
      {
        'title': 'Parametrización del Plan de Trabajo',
        'url': 'fullscreen.workPlanParametrization',
        'rolesAllowed': [GlobalConfig.userRolesIds.workPlanAdmin,GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.support,
        GlobalConfig.userRolesIds.gerencialConsultant]
      },
      {
        'title': 'Crear plan',
        'url': '#',
        'onclick': 'showModalCreateWorkplan',
        'rolesAllowed': [GlobalConfig.userRolesIds.workPlanAdmin,GlobalConfig.userRolesIds.generalAdmin]
      },
      {
        'title': 'Criterios de evaluación',
        'url': 'workPlanParametrization.criteriaListView',
        'rolesAllowed': [GlobalConfig.userRolesIds.workPlanAdmin,GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.support,
        GlobalConfig.userRolesIds.unitAdmin]
      },
      {
        'title': 'Asignación de evaluadores',
        'url': 'workPlanParametrization.workPlanAssignmentOfEvaluators',
        'rolesAllowed': [GlobalConfig.userRolesIds.workPlanAdmin,GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.support,
        GlobalConfig.userRolesIds.gerencialConsultant, GlobalConfig.userRolesIds.unitAdmin]
      },
      {
        'title': 'Situaciones especiales',
        'url': 'workPlanParametrization.specialSituationsView',
        'rolesAllowed': [GlobalConfig.userRolesIds.workPlanAdmin,GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.support,
        GlobalConfig.userRolesIds.gerencialConsultant, GlobalConfig.userRolesIds.unitAdmin]
      },
      {
        'title': 'Activar plan de trabajo',
        'url': 'workPlanParametrization.activateWorkPlan',
        'rolesAllowed': [GlobalConfig.userRolesIds.workPlanAdmin,GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.support,
        GlobalConfig.userRolesIds.gerencialConsultant, GlobalConfig.userRolesIds.unitAdmin]
      },
      {
        'title': 'Módulos',
        'url': 'workPlanParametrization.modules',
        'rolesAllowed': [GlobalConfig.userRolesIds.workPlanAdmin,GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.support,
        GlobalConfig.userRolesIds.gerencialConsultant, GlobalConfig.userRolesIds.unitAdmin,GlobalConfig.userRolesIds.profileAdmin,GlobalConfig.userRolesIds.adminPortfolio]
      }
    ]
  }])
  .name



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/index.js